import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation PreRateChat($id: ID!, $rating: Rating!) {
    preRateChat(id: $id, rating: $rating) {
      id
      rating
    }
  }
`);
